<div class="my-5">
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.companyInfo.inspect.title"></sm-page-header>
  <div class="content">
    <sm-form-builder [formObject]="formObject" class="w-full px-4"></sm-form-builder>

    <p-tabs [(value)]="selectedTab" (valueChange)="onTabChange($event)" scrollable class="mt-4 bg-transparent">
      <p-tablist>
        <p-tab value="0">{{ 'settings.companyInfo.tabs.users' | translate }}</p-tab>
        <p-tab value="1">{{ 'settings.companyInfo.tabs.activities' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <sm-company-members [usersSociete]="company.usersSociete"></sm-company-members>
        </p-tabpanel>
        <p-tabpanel value="1">
          <sm-activity [companyId]="id" [activity]="company.activites"></sm-activity>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>